import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { GetUserPermissionsResponse } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getUserPermissions = async (
  userId: string,
  orgId: string,
): Promise<GetUserPermissionsResponse> => {
  const response = await axiosClient.get(
    `/${orgId}/users/${userId}/permissions`,
  );
  return response.data;
};

export function useGetUserPermissions(
  userId: string,
  orgId: string,
  queryOptions?: Partial<
    UseQueryOptions<GetUserPermissionsResponse[string], HttpError>
  >,
) {
  return useQuery({
    queryKey: ["user-permissions", userId],
    queryFn: async () => {
      const response = await getUserPermissions(userId, orgId);
      return response[orgId] ?? { roles: [], roleGroup: null };
    },
    enabled: !!userId && !!orgId,
    ...queryOptions,
  });
}
